import {Getters} from "vuex-smart-module";
import QrServerState, {QrServerStatus} from "@/store/modules/qr-server/qr-server-state";

export default class QrServerGetters extends Getters<QrServerState> {
    get codesStatusMessage(): string {
        return this.resolveStatusMessage(this.state.codesStatus, "codes");
    }

    get logsStatusMessage(): string {
        return this.resolveStatusMessage(this.state.logsStatus, "logs");
    }

    private resolveStatusMessage(status: QrServerStatus, subject: "codes" | "logs"): string {
        switch (status) {
        case QrServerStatus.NotImplemented:
            return "This feature is unavailable for this building.";
        case QrServerStatus.Unauthenticated:
            return "Authentication required.";
        case QrServerStatus.Forbidden:
            return "Insufficient privileges.";
        case QrServerStatus.Empty:
            return subject === "codes" ? "No codes found." : "No logs found.";
        case QrServerStatus.Failed:
            return subject === "codes" ? "Failed to load codes." : "Failed to load logs.";
        case QrServerStatus.Loading:
            return subject === "codes" ? "Loading access codes." : "Loading access logs.";
        default:
            return "Status unknown.";
        }
    }
}
